import React from 'react'
import { Link } from 'react-router-dom'
import { PageHeader }  from 'modules/common/components/grid'
import { H2, P, HR, A, B, UL, StyledLink, ProfileFigure }  from 'modules/common/components/elements'

// import { StaticMap, MapLink } from 'modules/common/components/ui/StaticMap'
// import CourseDetails from 'modules/pros/components/CourseDetails'

const ProductPageHeader = ({
  display_name,
  title,
  profile_banner: profile_banner = [],
  picture: picture = [],
  default_course: default_course = [{ label: '', id: undefined }],
  scrollToProduct: scrollToProduct = () => {},
  phone,
  website,
  locale,
  geolocation,
  name,
  address,
  id,
  machine_name,
  localized,
  ctaBtnTxt = localized("pro.cta_booking_link"),
  }) => {

  const pictureSrc = picture instanceof Array && picture.length > 0 ? picture[0].formatted_large : undefined

  return(
    <PageHeader mobileOrderSecond id="page-header">
        <ProfileFigure style={{ backgroundImage: `url(${pictureSrc})` }}>
          <img className="figure-pro--img" src={pictureSrc} alt={`${display_name}`} />
        </ProfileFigure>
        <H2 medium className="title--main" halfMargin>
          {`${display_name}`}
        </H2>
        <P textDark halfMarginTop noBottomMargin>
          {title && <B block>{title}</B>}
        </P>
        <UL plain noTopMargin>
          { default_course && default_course
            .filter(item => item !== undefined)
            .map(({id = undefined, label = ''}) => (id && <li key={`link-${id}`}><StyledLink to={`/courses/${id}`} textDark>{label}</StyledLink></li>))
          }
        </UL>
        <P textDark halfMarginTop className="show-for-large">
          <a onClick={scrollToProduct} className="btn" href="#product">
            {ctaBtnTxt}
          </a>
        </P>
        <P textDark halfMarginBottom>
          <Link className="btn btn--ghost" to={`/pros/${machine_name}`}>
            {localized('event.label_pro_page_link')}
          </Link>
        </P>
        <HR className="stretch" />
        <P className="contact contact-pro">
          { phone && <A textDark href={`tel:${phone}`} block noHover>{localized("pro.phone")} {phone}</A>}
          { website && <A textDark href={website} block>{website}</A>}
        </P>
        { /*
          (default_course && default_course.length === 1) && default_course.filter(item => item !== undefined).map(({id, geolocation, name, address}) => (
          <div key={id} className="course-details pro--course-details hide-for-medium-only">
            <div>
              <div className="pro--course-details-item">
                <StaticMap className="stretch" lang={locale} coordinates={geolocation} />
                <MapLink lang={locale} coordinates={geolocation}>
                  {localized("course.label_map_link")}
                </MapLink>
                <HR
                  halfMarginTop
                  className="stretch"
                />
              </div>
              <CourseDetails 
                name={name}
                address={address}
                id={id}
                txt={localized("pro.open_club_page")}
              />
            </div>
          </div>)
          )
        */}
    </PageHeader>

  )
}

export default ProductPageHeader



// WEBPACK FOOTER //
// ./src/modules/events/components/EventPageHeader.js